import React, { Component } from "react";

class DiffView extends Component {
  // loadDiffView(diff) {
  //   if (!diff) {
  //     return;
  //   }

  //   const view = diff.split("\n").map((line, index) => {
  //     let color = "transparent";
  //     if (line[0] === "+") {
  //       color = "green";
  //     } else if (line[0] === "-") {
  //       color = "red";
  //     }

  //     return (
  //       <pre key={index} className={color}>
  //         {line}
  //       </pre>
  //     );
  //   });

  //   return <div>{view}</div>;
  // }

  render() {
    return <div className="diff-container" dangerouslySetInnerHTML={{ __html: this.props.diff }}/>; 
  }
}

export default DiffView;



// WEBPACK FOOTER //
// ./src/components/swaggers-diff/DiffView.js